export default __webpack_public_path__ + "static/media/1382.86005030.png";